import React, { useMemo, useState } from "react";
import { FiUser } from "react-icons/fi";
import SettingsHeader from "./SettingsHeader";

const UserIcon = FiUser;

export default function ProfileSettingsScreen({
  t,
  onBack,
  onChange,
  onSave,
  onOpenPassword,
  parentData,
  form = {},
}) {
  const [saving, setSaving] = useState(false);
  const username = useMemo(
    () => parentData?.username || parentData?.email || form.email || "",
    [parentData, form.email]
  );

  const submit = async (event) => {
    event.preventDefault();
    setSaving(true);
    try {
      await onSave?.();
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="pp-settings-screen pp-settings-subscreen pp-settings-profile-screen">
      <SettingsHeader
        t={t}
        onBack={onBack}
      />

      <section className="pp-settings-card pp-settings-form-card">
        <div className="pp-settings-card-heading">
          <span className="pp-settings-card-icon" aria-hidden="true">
            <UserIcon />
          </span>
          <div>
            <h3>{t("parentPortal.settings.profile", { defaultValue: "Profile" })}</h3>
            <p>{t("parentPortal.settings.profile_intro", { defaultValue: "Manage the details used for your account." })}</p>
          </div>
        </div>

        <form className="pp-settings-form" onSubmit={submit}>
          <label className="pp-settings-field">
            <span>{t("parentPortal.settings.username", { defaultValue: "Username" })}</span>
            <input value={username} readOnly />
          </label>

          <label className="pp-settings-field">
            <span>{t("parentPortal.first_name", { defaultValue: "First name" })}</span>
            <input name="firstName" value={form.firstName || ""} onChange={onChange} />
          </label>

          <label className="pp-settings-field">
            <span>{t("parentPortal.last_name", { defaultValue: "Last name" })}</span>
            <input name="lastName" value={form.lastName || ""} onChange={onChange} />
          </label>

          <label className="pp-settings-field">
            <span>{t("parentPortal.email", { defaultValue: "Email" })}</span>
            <input name="email" type="email" value={form.email || ""} onChange={onChange} />
          </label>

          <label className="pp-settings-field">
            <span>{t("parentPortal.settings.language", { defaultValue: "Language" })}</span>
            <select name="language" defaultValue="nl">
              <option value="nl">Nederlands</option>
              <option value="en">English</option>
            </select>
          </label>

          <div className="pp-settings-actions">
            <button type="button" className="pp-settings-secondary-button" onClick={onOpenPassword}>
              {t("parentPortal.settings.change_password", { defaultValue: "Change password" })}
            </button>

            <button type="submit" className="pp-settings-primary-button" disabled={saving}>
              {saving
                ? t("common.saving", { defaultValue: "Saving..." })
                : t("common.save", { defaultValue: "Save" })}
            </button>
          </div>
        </form>
      </section>
    </div>
  );
}
